import React, { useEffect, useLayoutEffect, useRef, useMemo } from 'react';
import cn from 'classnames';
import debounce from 'lodash.debounce';
import PropTypes from 'prop-types';
import styles from './accordion.module.scss';

const AccordionContent = (props) => {
  const collapseRef = useRef();

  const calculateHeight = useMemo(() => {
    return debounce(() => {
      const content = collapseRef.current;
      if (!content) return;
      content.parentElement.style.setProperty(
        '--collapse-height',
        `${('height', content.scrollHeight)}px`
      );
    }, 250);
  }, []);

  useLayoutEffect(() => {
    calculateHeight();
  }, [props.children]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    window.addEventListener('resize', calculateHeight);

    return () => {
      window.removeEventListener('resize', calculateHeight);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    // eslint-disable-next-line react/prop-types
    <div id={props.id} className={cn(styles.content, props.className)}>
      <div ref={collapseRef}>{props.children}</div>
    </div>
  );
};

AccordionContent.propTypes = {
  /** An ID for the element. Useful to select for testing */
  id: PropTypes.string,
  /** Pass children elements to this element */
  children: PropTypes.node,
};

AccordionContent.defaultProps = {
  id: undefined,
  children: undefined,
};

export default AccordionContent;
